var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeServicesNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.125L15.1875 3.9375V8.0625C15.1875 11.3625 12.7875 14.3625 9 15.5625C5.2125 14.3625 2.8125 11.3625 2.8125 8.0625V3.9375L9 1.125Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1 6.6H9.9V8.1H11.4V9.9H9.9V11.4H8.1V9.9H6.6V8.1H8.1V6.6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeServicesNotificationIcon);
export default __webpack_public_path__ + "static/media/home-services-notification-icon.f4ac421909534fcb82a821f0fa1fb8e0.svg";
export { ForwardRef as ReactComponent };